export const isWebView = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const appPlatform = params.get("app_platform");
  const appPlatforms = ["ios", "android"];

  if (appPlatforms.includes(appPlatform)) {
    localStorage.setItem("app_platform", appPlatform);
  }

  return (
    appPlatforms.includes(appPlatform) ||
    Boolean(localStorage.getItem("app_platform"))
  );
};
